import { useMemo } from 'react';

export function flattenLevels(levels) {
  return levels.reduce(
    (accumulator, level) => getFlatLevel(accumulator, level),
    {},
  );
}

function getFlatLevel(accumulator, level, parentRefId) {
  const { refId, children, ...restProps } = level;
  // eslint-disable-next-line no-param-reassign
  accumulator[refId] = { ...restProps, refId, parentRefId };
  if (level.children) {
    // eslint-disable-next-line no-param-reassign
    accumulator[refId].children = children;
    level.children.forEach((child) => getFlatLevel(accumulator, child, refId));
  }

  return accumulator;
}

export default function useGetLevels(levels) {
  return useMemo(() => flattenLevels(levels), [levels]);
}
